import React from 'react';
import './feature.css';

// Define types for props
interface FeatureProps {
    icon: string;
    title: string;
    description: string;
}

// Feature component
const Feature: React.FC<FeatureProps> = ({ icon, title, description }) => (
    <div className="feature-card">
      <img className="icon" src={icon} alt={title} />
      <h3 className="title">{title}</h3>
      <p className="description">{description}</p>
    </div>
);

export {
    Feature
};

export type { FeatureProps };
